import moment, { Moment } from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import analyticsRemote from '../../../api/analyticsRemote';
import AirlineType from '../../../models/AirlineType';
import { CustomerWaitSearchOption, CustOrdersData, filterOptions, customers, CustItemData } from '../../../models/Analytics';
import ApiResponse from '../../../models/ApiResponse';

import ResponseError from '../../../models/ResponseError';
import { receiveError } from '../../../store/actions/notificationAction';
import { SEARCH_OPTIONS_SCHEMA } from '../../../utils/Analytics';

import TopCustomers from './TopCustomers';
import { ExportToCsv } from 'export-to-csv';

interface TopCustomersContainerState {
  searchOptions: CustomerWaitSearchOption;
  filterOptions: filterOptions;
  progress: boolean;
  customers: customers[];
  tab_id: string;
  intvl: number;
  ship_type: string;
  airlines: AirlineType[];
  pattern: Array<any>;
  shipmentData: Array<any>;
  shipmentCol: Array<any>;
  orders: CustOrdersData[];
  data: CustOrdersData[];
  exceedHours: number;
};

interface TopCustomersContainerProps {
  receiveError: Function;
  airlines: AirlineType[];
  startDate: Moment;
  endDate: Moment;
  handleChangeDate: (dateType: string, event: any) => void;
};

class TopCustomersContainer extends Component<TopCustomersContainerProps, TopCustomersContainerState> {
  state = {
    filterOptions: {
      process: true,
      carriers: true,
      rank_by: true
    },
    progress: false,
    searchOptions: { ...SEARCH_OPTIONS_SCHEMA, startDate: this.props.startDate, endDate: this.props.endDate },
    data: [],
    orders: [],
    airlines: this.props.airlines,
    customers: [],
    tab_id: '',
    intvl: 4,
    ship_type: 'ALL',
    pattern: [],
    shipmentData: [],
    shipmentCol: [],
    exceedHours: 0
  }

  componentWillReceiveProps(nextProps: TopCustomersContainerProps) {
    let searchOptions = this.state.searchOptions;
    if (nextProps.startDate !== this.state.searchOptions.startDate || nextProps.endDate !== this.state.searchOptions.endDate) {
      searchOptions.startDate = nextProps.startDate;
      searchOptions.endDate = nextProps.endDate;
      this.setState({ searchOptions }, () => {
        this.loadOdersData();
      });
    }
    if (nextProps.airlines != this.state.airlines) {
      let carr = nextProps.airlines.map(a => a.iata_code);
      this.setState({ airlines: nextProps.airlines, searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.filterOdersData();
      });
    }
  }

  componentDidMount() {
    if (this.state.airlines.length > 0) {
      let carr = this.state.airlines.map((a: AirlineType) => a.iata_code);
      this.setState({ searchOptions: { ...this.state.searchOptions, carr: carr.toString() } }, () => {
        this.filterOdersData();
      });
    }
    this.loadOdersData();
    this.getPattern();
  }

  loadOdersData = (): void => {
    this.setState({ progress: true }, () => {
      let searchOptions = this.state.searchOptions;
      let startDate: string = searchOptions.startDate.format('YYYYMMDD');
      let endDate: string = searchOptions.endDate.format('YYYYMMDD');
      let pickUp: boolean = searchOptions.pickUp;
      let dropOff: boolean = searchOptions.dropOff;
      analyticsRemote.getTopCustomers(
        startDate,
        endDate,
        pickUp,
        dropOff,
        this.state.exceedHours
      ).then((resp: ApiResponse<Array<CustOrdersData>>) => {
        const data: Array<CustOrdersData> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        if (data) {
          this.setState({ data, searchOptions: { ...this.state.searchOptions } }, () => {
            this.filterOdersData();
          });
        }
        if (error) {
          this.props.receiveError(error);
        };
        this.setState({ progress: false });
      });
    });

  }

  filterOdersData = (): void => {
    let orders = this.state.airlines.length > 0 && this.state.searchOptions.carr != '' ? this.state.data : [];

    // Handled Carriers
    if (this.state.searchOptions.carr && this.state.searchOptions.carr != '') {
      orders = orders.filter((o: CustOrdersData) => {
        let carr = false;
        o.items.map((i: CustItemData) => {
          if (i.iata_code && this.state.searchOptions.carr.includes(i.iata_code)) {
            carr = true;
          }
        })
        if (carr)
          return o;
      })
    }

    this.setState({ orders }, () => {
      if (this.state.searchOptions.entity == 'forwarder') {
        this.getTopCustoner();
      } else { this.getTopCompany(); }
      this.getPattern();
      this.getShipmentData();
    })
  }

  handleChangeProcess = (type: string, value: boolean): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: value };
    this.setState({ searchOptions: searchOptions }, () => {
      this.loadOdersData();
    });
  }

  handleChangeCarriers = (type: string, value: boolean): void => {
    const searchOptions = { ...this.state.searchOptions };
    let carr = searchOptions.carr.split(',');
    if (type == 'GLOABL' && !value) {
      carr = [];
      searchOptions.carrCheck = value;
    } else if (type == 'GLOABL' && value) {
      carr = this.state.airlines.map(a => a.iata_code);
      searchOptions.carrCheck = value;
    } else {
      if (value) {
        carr.push(type);
      } else {
        var index = carr.indexOf(type);
        if (index !== -1) {
          carr.splice(index, 1);
        }
      }
    }
    searchOptions.carr = carr.toString();
    this.setState({ searchOptions: searchOptions }, () => {
      this.filterOdersData();
    });
  }

  handleChangeOption = (type: string, event: any): void => {
    let searchOptions = { ...this.state.searchOptions, [type]: event }
    this.setState({ searchOptions: searchOptions }, () => {
      if (type == 'rank_by') {
        this.getRanked();
      } else if (type == 'entity') {
        if (event == 'forwarder') {
          this.getTopCustoner();
        } else {
          this.getTopCompany();
        }
      }
    });
  }
  handleChange = (type: string, event: any): void => {
    switch (type) {
      case 'tab_id':
        this.setState({ tab_id: event }, () => {
          this.getPattern();
          this.getShipmentData();
        })
        break;
      case 'intvl':
        this.setState({ intvl: event }, () => {
          this.getPattern();
        })
        break;
      case 'ship_type':
        this.setState({ ship_type: event }, () => {
          this.getShipmentData();
        })
        break;
    }
  }

  handleExceedHoursChange = (value: any): void => {
    // Convert empty string or null to undefined
    const parsedValue = value === '' || value === null ? undefined : value;
    
    this.setState({ exceedHours: parsedValue }, () => {
      this.loadOdersData();
    });
  }
  
  handleExport = (type: string): void => {
    let headers: string[] = [];
    let data: any[] = [];
    if (type == 'tab') {
      headers = ['Customer', "Tonnage", 'Pieces', 'Awbs', 'Orders'];
      this.state.customers.map((c: any) => {
        data.push([c.name, c.wgt, c.pcs, c.awbs, c.orders]);
      })
    }
    if (type == 'pattern') {
      headers = ['TIME', 'Pick Ups MON', 'Drop Offs MON', 'Pick Ups TUE', 'Drop Offs TUE', 'Pick Ups WED', 'Drop Offs WED', 'Pick Ups THU', 'Drop Offs THU', 'Pick Ups FRI', 'Drop Offs FRI', 'Pick Ups SAT', 'Drop Offs SAT', 'Pick Ups SUN', 'Drop Offs SUN'];
      this.state.pattern.map((p: any) => {
        data.push([
          p.time,
          p.mon.po, p.mon.do,
          p.tue.po, p.tue.do,
          p.wed.po, p.wed.do,
          p.thu.po, p.thu.do,
          p.fri.po, p.fri.do,
          p.sat.po, p.sat.do,
          p.sun.po, p.sun.do,
        ]);
      });
    }
    if (type == 'shipment') {
      headers = this.state.shipmentCol.map((s: any) => s.title);
      this.state.shipmentData.map((s: any) => {
        let d: any = [];
        this.state.shipmentCol.map((c: any) => {
          d.push(s[c.field]);
        })
        data.push(d);
      });
    }
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: false,
      filename: 'Top Customers',
      useTextFile: false,
      useBom: false,
      useKeysAsHeaders: false,
      headers: headers
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(data);
  }

  getTopCustoner = (): void => {
    let customers: any[] = [];
    this.state.orders.map((o: CustOrdersData) => {
      if (o && o.forwarder) {
        const exists = customers.some(c => c.id === o.forwarder.id + o.forwarderlocation);
        if (!exists) {
          customers.push({ id: o.forwarder.id + o.forwarderlocation, name: o.forwarder.type != 'forwarder' ? o.forwarder.name : o.forwarder.name + ' | ' + (o.forwarderlocation || ''), wgt: 0, pcs: 0, awbs: 0, orders: 0 });
        }
        const index = customers.findIndex(c => c.id === o.forwarder.id + o.forwarderlocation);
        if (index >= 0) {
          o.items.map((i: CustItemData) => {
            customers[index].wgt += i.weight;
            customers[index].pcs += i.pieces;
            customers[index].awbs++;
          })
          customers[index].orders++;
        }
      }
    });
    this.setState({ customers }, () => {
      this.getRanked();
    });
  }

  getTopCompany = (): void => {
    let customers: any[] = [];
    this.state.orders.map((o: CustOrdersData) => {
      if (o && o.company) {
        if (o.company.id && !customers[o.company.id]) {
          customers[o.company.id] = { id: o.company.id, name: o.company.name, wgt: 0, pcs: 0, awbs: 0, orders: 0 };
        }
        o.items.map((i: CustItemData) => {
          if (o.company.id) {
            customers[o.company.id].wgt += i.weight;
            customers[o.company.id].pcs += i.pieces;
            customers[o.company.id].awbs++;
          }
        });
        o.company.id ? customers[o.company.id].orders++ : {};
      }
    });
    this.setState({ customers }, () => {
      this.getRanked();
    });
  }

  getRanked = (): void => {
    let customers: any = this.state.customers;
    let key = this.state.searchOptions.rank_by;
    customers.sort(function (a: any, b: any) {
      return parseFloat(b[key]) - parseFloat(a[key]);
    });
    this.setState({ customers, tab_id: customers[0] && customers[0].id || 0 }, () => {
      this.getPattern();
      this.getShipmentData();
    });
  }

  getPattern = (): void => {
    let pattern: any = [];
    let i = 0;
    let intvl = this.state.intvl;
    while (i < 24) {
      pattern.push({
        time: i.toString().replace(/^(\d)$/, '0$1') + '00-' + (((i + intvl) == 24 ? 0 : (i + intvl))).toString().replace(/^(\d)$/, '0$1') + '00',
        mon: { po: 0, do: 0 },
        tue: { po: 0, do: 0 },
        wed: { po: 0, do: 0 },
        thu: { po: 0, do: 0 },
        fri: { po: 0, do: 0 },
        sat: { po: 0, do: 0 },
        sun: { po: 0, do: 0 },
      });
      i = i + intvl;
    }
    this.state.orders.map((o: CustOrdersData) => {
      if ((this.state.searchOptions.entity == 'forwarder' && (o.forwarder && this.state.tab_id == o.forwarder.id + o.forwarderlocation)) || (this.state.searchOptions.entity == 'company' && (o.company && this.state.tab_id == o.company.id + ''))) {
        let date = moment(o.create_date);
        let index = parseInt((date.hour() / intvl).toString());
        let day = date.format('ddd').toString().toLowerCase();
        if (o.order_type == 'do') {
          pattern[index][day].do++;
        } else {
          pattern[index][day].po++;
        }
      }
    });
    this.setState({ pattern });
  }

  getShipmentData = (): void => {
    let shipmentCol = [
      { title: 'Date', field: 'date', type: 'date', cellStyle: { textAlign: 'center', whiteSpace: 'nowrap' } },
      { title: 'Order Nbr', field: 'number', type: 'numeric', cellStyle: { textAlign: 'center' } },
      { title: 'Mixed?', field: 'mixed', type: 'numeric', cellStyle: { textAlign: 'center' } },
      { title: 'Process', field: 'process', type: 'numeric', cellStyle: { textAlign: 'center' } },
      { title: 'Forwarder', field: 'forwarder', cellStyle: { textAlign: 'left' } },
      { title: 'Trucking Co', field: 'company', cellStyle: { textAlign: 'left' } },
      { title: 'Driver', field: 'driver', cellStyle: { textAlign: 'left' } },
      { title: 'Awb', field: 'awb', type: 'numeric', cellStyle: { textAlign: 'center' } },
      { title: 'Pcs', field: 'pcs', type: 'numeric', cellStyle: { textAlign: 'center' } },
      { title: 'Weight', field: 'wgt', type: 'numeric', cellStyle: { textAlign: 'center' } },
      { title: 'Check In', field: 'check_in', type: 'numeric', cellStyle: { textAlign: 'center' } },
      { title: 'Check out', field: 'check_out', type: 'numeric', cellStyle: { textAlign: 'center' } },
    ];
    if (this.state.ship_type == 'AWB') {
      shipmentCol = [
        { title: 'Date', field: 'date', type: 'date', cellStyle: { textAlign: 'center', whiteSpace: 'nowrap' } },
        { title: 'Order Nbr', field: 'number', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Process', field: 'process', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Awb', field: 'awb', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Kind Of Exception', field: 'exceptions', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Kind of Packaging', field: 'packaging', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Contents Damaged?', field: 'contents_damaged', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Pieces Not Dlvd', field: 'not_delivered_pieces', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Notes', field: 'note', type: 'numeric', cellStyle: { textAlign: 'center' } },
      ];
    }
    if (this.state.ship_type == 'CUSTOMER') {
      shipmentCol = [
        { title: 'Date', field: 'date', type: 'date', cellStyle: { textAlign: 'center', whiteSpace: 'nowrap' } },
        { title: 'Order Nbr', field: 'number', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Process', field: 'process', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Awb', field: 'awb', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Pcs', field: 'pcs', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Weight', field: 'wgt', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Commodity', field: 'comodity', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Driver Check In', field: 'check_in', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Driver Check out', field: 'check_out', type: 'numeric', cellStyle: { textAlign: 'center' } },
        { title: 'Customer Error Details', field: 'general_remarks', type: 'numeric', cellStyle: { textAlign: 'center' } },
      ];
    }
    let shipmentData: any = [];
    this.state.orders.map((o: CustOrdersData) => {
      let carr: string[] = [];
      o.items.map((i: CustItemData) => {
        if (!carr.includes(i.iata_code)) {
          carr.push(i.iata_code);
        }
      });
      o.items.map((i: CustItemData) => {
        if ((this.state.searchOptions.entity == 'forwarder' && (o.forwarder && this.state.tab_id == o.forwarder.id + o.forwarderlocation)) || (this.state.searchOptions.entity == 'company' && (o.company && this.state.tab_id == o.company.id + ''))) {
          if (this.state.ship_type == 'ALL' || (this.state.ship_type == 'AWB' && i.exceptions.length > 0) || (this.state.ship_type == 'CUSTOMER' && i.remarks.customer_error))
            shipmentData.push({
              date: moment(o.create_date).format('DD MMM YY'),
              number: o.number,
              contents_damaged: i.contents_damaged ? 'Yes' : (i.contents_damaged === false ? 'No' : 'Unknown'),
              note: i.note,
              exceptions: (i.exceptions.map((e) => e.name)).join(', '),
              packaging: (i.packaging.map((m) => m.name)).join(', '),
              not_delivered_pieces: i.not_delivered_pieces > 0 ? i.not_delivered_pieces + ' / ' + i.not_delivered_weight + 'K' : '',
              mixed: carr.length == 1 ? 'No' : 'Yes',
              process: o.order_type == 'po' ? 'Pick Up' : 'Drop Off',
              forwarder: o.forwarder.type != 'forwarder' ? o.forwarder.name : o.forwarder.name + ' | ' + (o.forwarderlocation || ''),
              company: o.company.name,
              driver: o.driver_name,
              awb: i.awb_code + '-' + i.awb_number,
              comodity: i.export_metadata.comodityType,
              pcs: i.pieces,
              wgt: i.weight,
              check_in: moment(o.driver.created || o.create_date).format('D/MM/YY HH:mm'),
              check_out: moment(o.delivered_timestamp).format('D/MM/YY HH:mm'),
              general_remarks: i.remarks.general_remarks || ''
            });
        }
      });
    });
    this.setState({ shipmentData, shipmentCol });
  }

  render() {
    return (
      <TopCustomers
        progress={this.state.progress}
        startDate={this.state.searchOptions.startDate}
        endDate={this.state.searchOptions.endDate}
        pickUp={this.state.searchOptions.pickUp}
        dropOff={this.state.searchOptions.dropOff}
        carrCheck={this.state.searchOptions.carrCheck}
        carr={this.state.searchOptions.carr}
        entity={this.state.searchOptions.entity}
        rank_by={this.state.searchOptions.rank_by}
        tab_id={this.state.tab_id}
        intvl={this.state.intvl}
        ship_type={this.state.ship_type}
        filterOptions={this.state.filterOptions}
        airlines={this.state.airlines}
        customers={this.state.customers}
        pattern={this.state.pattern}
        shipmentData={this.state.shipmentData}
        shipmentCol={this.state.shipmentCol}
        handleChangeDate={this.props.handleChangeDate}
        handleChangeProcess={this.handleChangeProcess}
        handleChangeCarriers={this.handleChangeCarriers}
        handleChangeOption={this.handleChangeOption}
        handleChange={this.handleChange}
        handleExport={this.handleExport}
        handleExceedHoursChange={this.handleExceedHoursChange}
        exceedHours={this.state.exceedHours} 
      />
    )
  };
};

const mapStateToProps = (state: any) => {
  return {
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TopCustomersContainer);